function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_key2");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 28.77,
  y: 13.35,
  width: 8.52,
  height: 6.09,
  rx: 2.5,
  transform: "translate(20.03 -18.11) rotate(42.95)",
  fill: "#fff",
  stroke: "#282c34",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 21.65,
  y: 15.81,
  width: 1.22,
  height: 24.34,
  rx: 0.5,
  transform: "translate(25.03 -7.66) rotate(42.95)",
  fill: "#282c34",
  stroke: "#282c34",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 13.11,
  y: 37.49,
  width: 6.09,
  height: 1.22,
  rx: 0.5,
  transform: "translate(30.29 -0.8) rotate(42.95)",
  fill: "#282c34",
  stroke: "#282c34",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 17.23,
  y: 34.37,
  width: 3.65,
  height: 1.22,
  rx: 0.5,
  transform: "translate(28.94 -3.61) rotate(42.95)",
  fill: "#282c34",
  stroke: "#282c34",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var SvgIconKey = function SvgIconKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-key.49a10085.svg";
export { ForwardRef as ReactComponent };